import { InjectionToken } from '@angular/core';

export interface LocaleServiceInterface {
  defaultLang: string;
  locale: string;
  thousandSeparator: string;
  decimalMarker: '.' | ',' | ['.', ','];
}

export const ANGULAR_LOCALE_SERVICE_TOKEN = new InjectionToken<LocaleServiceInterface>('AngularLocaleServiceToken', {
  providedIn: 'root',
  // default values, pls keep them ugly, so we know if the token is not provided from app
  factory: () => ({ defaultLang: 'en', locale: 'en', thousandSeparator: '-', decimalMarker: ',' })
});
